import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReferenceParams, Res } from 'src/app/models';
import { ApiService } from '../../api.service';


@Injectable({
  providedIn: 'root'
})
export class ApiOzonSettingsService {

  constructor(
    private api: ApiService
  ) { }


  /**
   * 
   * @param params 
   * @param moduleName 
   * @returns 
   */
  getReferences(params: ReferenceParams, moduleName: string): Observable<Res> {

    return this.api.post('references/' + moduleName, params, 'private');
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  save(params: any): Observable<Res> {

    return this.api.post('ozon/importProducts', params, 'private', 'integrationOzon');
  }

  /**
   * 
   * @returns Observable<Res>
   */
  uploadInfo(): Observable<Res> {

    return this.api.get('ozon/getCredentialData', '', 'private', 'integrationOzon');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  uploadSave(params: any): Observable<Res> {

    return this.api.post('ozon/saveCredentialData', params, 'private', 'integrationOzon');
  }
}
